@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.container {
  top: 0;
  left: 0;
  z-index: 3;
  position: fixed;
}

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: none;
  padding: 5px;

  transition: opacity 0.2s ease-in-out;

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }

  @include for-phone-only {
    background-color: var(--light-100);
  }

  &.focused {
    background: var(--default-bg);
    box-shadow: 0 2px 12px 0 var(--dark-4);
    @include blur(35px);

    .promptInput {
      border-radius: 6px;
      box-shadow: inset 0 0 0 2px var(--selected-stroke);
      background: var(--light-100, #fff);
      caret-color: var(--selected-fill);

      [data-autopilot-system-redesign='on'] & {
        box-shadow: none;
        border: 1px solid var(--dark-90);
      }

      textarea {
        margin-bottom: 2px;
        caret-color: var(--selected-stroke);
      }
    }
  }

  .promptInput {
    border-radius: 8px;
    box-shadow: 0 9px 24px 0 var(--dark-7), 0 0 4px 0 var(--dark-8), 0 2px 10px 0 var(--dark-6);
  }
}

.optionsContainer {
  display: flex;
  flex-direction: column;

  .voiceLabel {
    @include sm-medium;
  }

  .topRow,
  .topLeft,
  .topRight {
    display: flex;
    align-items: center;
    gap: 4px;

    .reviseButton {
      color: var(--action-60);
    }
  }

  .leftActions {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .topRow {
    width: 100%;
    justify-content: space-between;
  }
}

@media (min-width: $phoneMaxWidth) {
  .wrapper {
    gap: 12px;
    padding: 10px;
    border-radius: 12px;

    &.focused {
      border-radius: 10px;
      background: var(--light-60);
      box-shadow: 1px 1px 0 0 var(--light-100) inset, 0 8px 37px 0 var(--dark-10);
      @include blur;
    }
  }
}
